
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import dayjs from "dayjs";
import { checkMoneyEl, myIsNaN } from "@common/src/utils/verify";
import { addCurrencySymbol } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";
const employee = namespace("employee");
const common_app = namespace("common_app");
const base = namespace("base");
@Component({
  components: { TableEnableFlag }
})
@Table("loadListData")
export default class WageAccountig extends Vue {
  @employee.Action getStaffMonthlySalaryPage;
  @employee.Action getStaffMonthlySalaryRecordPage;
  @employee.Action grantStaffMonthlySalaryRecord;
  @employee.Action getStaffMonthlySalaryRecord;
  @employee.Action updateStaffMonthlySalaryRecord;
  @base.Action getDictionaryList;
  @common_app.State lang;
  dayjs = dayjs;
  addCurrencySymbol = addCurrencySymbol;
  checkMoneyEl = checkMoneyEl;
  t = t;
  searchForm = {
    staffName: "",
    salaryMonth: this.getTime
  };
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  partsList: any[] = [];
  showEditTips = false;
  createWageForm = {
    wageSetList: [],
    staffName: undefined,
    baseSalary: "",
    commissionWeight: "5",
    subsidy: "0",
    staffCode: "",
    employee: {
      staffName: "",
      userCode: ""
    },
    configId: "",
    recordId: ""
  };
  get countAmount() {
    return this.createWageForm.wageSetList
      .reduce((total, value, index, arr) => {
        if (arr[index].itemName === "月工资") {
          arr[index].itemValue = 0;
        }
        let getAount = total;
        if (value.calculationType === "decrease") {
          getAount = total - (myIsNaN(Number(value.itemValue)) ? 0 : Number(value.itemValue));
        } else if (value.calculationType === "increase") {
          getAount = total + (myIsNaN(Number(value.itemValue)) ? 0 : Number(value.itemValue));
        }
        return getAount;
      }, 0)
      .i18nToFixed();
  }
  get searchList() {
    return [
      {
        label: t("v210801.employee-name"),
        type: "input",
        value: "",
        prop: "staffName"
      },
      {
        label: t("v210831.accounting-month"),
        type: "month",
        clearable: false,
        value: this.getTime,
        defaultVlaue: this.getTime,
        prop: "salaryMonth"
      },
      {
        label: t("v210831.distribution-status"),
        type: "select",
        value: "",
        prop: "hasGrant",
        selectList: this.hasGrantObject
      }
    ];
  }
  hasGrantObject: any = [];
  categoryList: any[] = [];
  warehouseList: any = [];
  brandList: any = [];
  get getTime() {
    if (dayjs().date() >= 5) {
      return dayjs().subtract(1, "month").format("YYYYMM");
    } else {
      return dayjs().subtract(2, "month").format("YYYYMM");
    }
  }
  created() {
    this.init();
  }
  async init() {
    this.loadListData();
    this.getDictionaryList("salary_grant_status").then(data => {
      this.hasGrantObject = data;
    });
  }
  handleLinkPartsDetail(row) {
    let { href } = this.$router.resolve({
      path: `/setting/parts-edit/${row.partsCode}`
    });
    window.open(href, "_blank");
  }
  inventoryQty: any = "";
  inventoryAmount: any = "";
  fieldNameList = [];
  @Table.LoadDataMethod()
  loadListData() {
    return this.getStaffMonthlySalaryRecordPage({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      staffName: this.searchForm.staffName
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
      this.fieldNameList = data.data.fieldNameList;
      this.inventoryQty = data.data.monthlySalaryTotal;
      this.inventoryAmount = data.data.inventoryAmount;
      return data;
    });
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "partsCategoryCode") {
          this.searchForm[item.prop] = item.value[item.value.length - 1] || "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  go() {
    this.$router.push("/employee/employee-wage/wage-set");
  }
  async handleEdit(row) {
    this.showEditTips = true;
    this.createWageForm.employee = {
      staffName: row["员工姓名"],
      userCode: row.staffCode
    };
    this.createWageForm.recordId = row.recordId;
    const res = await this.getStaffMonthlySalaryRecord({
      recordId: row.recordId
    });
    this.createWageForm.wageSetList = res.data.slice(1);
    let ref = this.$refs.createWageForm as any;
    ref.clearValidate();
  }
  async handleSend(row) {
    const res = await this.grantStaffMonthlySalaryRecord({ recordId: row.recordId });
    if (res.code === "0") {
      this.$message.success(t("v210831.salary-payment-succeeded"));
      this.loadListData();
    } else {
      this.$message.warning(t("v210831.failed-to-pay"));
    }
  }
  async saveCreateDeploy() {
    let ref = this.$refs.createWageForm as any;
    ref.validate(async valid => {
      if (valid) {
        let params = {
          itemList: [
            { itemName: "staffCode", itemValue: this.createWageForm.employee.userCode },
            { itemName: "姓名", itemValue: this.createWageForm.employee.staffName },
            { itemName: "月工资", itemValue: this.countAmount }
          ],
          recordId: this.createWageForm.recordId
        };
        let filterSetList = this.createWageForm.wageSetList.map(item => {
          return { itemCode: item.itemCode || "", itemName: item.itemName || "", itemValue: item.itemValue || "" };
        });
        params.itemList.unshift(...filterSetList);
        const res = await this.updateStaffMonthlySalaryRecord(params);
        if (res.code === "0") {
          this.$message.success(t("base.update-success"));
          this.showEditTips = false;
          this.loadListData();
        } else {
          this.$message.success(t("v210831.edit-failed"));
        }
      } else {
        console.log(t("v210831.verification-failed"));
      }
    });
  }
  // ///
}
